export const GET_EXACT_ADDRESS = "GET_EXACT_ADDRESS";
export const GET_INTERSECTION = "GET_INTERSECTION";
export const ENABLE_GEOCODER = "ENABLE_GEOCODER";
export const DISABLE_GEOCODER = "DISABLE_GEOCODER";
